import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ShareService } from 'src/app/core/services/share.service';
import { ContactService } from 'src/app/core/services/contact.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-edit-workplan-dialog',
  templateUrl: './edit-workplan-dialog.component.html',
  styleUrls: ['./edit-workplan-dialog.component.css']
})
export class EditWorkplanDialogComponent implements OnInit {

  title: string;
  dataJson = [];

  statusList = [
    {
      value: 'ASIGNADO', name: "Asignado"
    },
    {
      value: 'LOGRADO', name: "Logrado"
    },
    {
      value: 'LOGRADO_PARCIALMENTE', name: "Logrado Parcialmente"
    },
    {
      value: 'NO_LOGRADO', name: "No Logrado"
    },
  ];

  workPlan = new FormGroup({
    date: new FormControl(null, Validators.required),
    status: new FormControl(null),
    amount: new FormControl(null),
    comment: new FormControl(null, Validators.required)
  })
  
  constructor(
    private shareService: ShareService,
    private contactService: ContactService,
    private userService: UserService,
    public dialogRef: MatDialogRef<EditWorkplanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditWorkplanModalModel) {
    this.title = data.title;
    this.dataJson = data.dataJson;    
  }

  ngOnInit(): void {
    //console.log(this.dataJson);
    this.workPlan.controls['date'].setValue(this.dataJson['date']);
    this.workPlan.controls['comment'].setValue(this.dataJson['comment']);
    this.workPlan.controls['status'].setValue(this.dataJson['status']);
    this.workPlan.controls['amount'].setValue(this.dataJson['amount']);
  }

  onConfirm() {
    if (this.workPlan.valid){
      
      let response = { data: this.workPlan.value, status: true }
      this.dialogRef.close(response);    
    }
  }

  onDismiss(): void {
    let response = { data: null, status: false }
    this.dialogRef.close(response);
  }

}

export class EditWorkplanModalModel {

  constructor(public title: string, public dataJson: Array<any>) {
  }
}
